import {ReactComponent as UserProfile} from './userProfile.svg';

export {
  UserProfile,
}
